export default "__VITE_ASSET__Dn9CA5Ek__"